import React, {useMemo} from "react"

import {kebabCase} from "lodash"
import PropTypes from "prop-types"

import colors from "../../styles/_default.colors.module.scss"
import {getContrastedColor} from "../../utils/colorUtil"
import Link, {LINK_VARIANTS} from "../Link/link"

import "./footerNew.scss"

const Footer = ({backgroundColor = colors.footerBackgroundColor, items, textColor = null}) => {
    const linkVariant = useMemo(
        () =>
            getContrastedColor(backgroundColor, [colors.footerTextDarkColor, colors.footerTextLightColor]) ===
            colors.footerTextLightColor
                ? LINK_VARIANTS.LIGHT
                : LINK_VARIANTS.DARK,
        [backgroundColor],
    )

    return (
        <footer aria-label="Pied de page" className="footer-compo" role="contentinfo" style={{backgroundColor}}>
            <nav aria-label="Liens du pied de page">
                {items.map((item, index) => (
                    <Link
                        className="footer-link"
                        href={item.href}
                        key={`footer-link-${index}-${kebabCase(item.label || "item")}`}
                        onClick={item.onClick}
                        openInNewTab={!!item.href}
                        route={item.route}
                        variant={linkVariant}
                    >
                        {item.label}
                    </Link>
                ))}
            </nav>
        </footer>
    )
}

Footer.propTypes = {
    backgroundColor: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string,
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func,
            route: PropTypes.string, // 💡 Pour indiquer une route, utiliser PagesArchitecture
        }),
    ).isRequired,
    textColor: PropTypes.string, // TODO Retirer la prop textColor quand elle n'est plus utiisée dans l'ensemble des projets
}

export default Footer
